import { render, staticRenderFns } from "./interaction-list.vue?vue&type=template&id=cd1f2cca&scoped=true&"
import script from "./interaction-list.vue?vue&type=script&lang=ts&"
export * from "./interaction-list.vue?vue&type=script&lang=ts&"
import style0 from "./interaction-list.vue?vue&type=style&index=0&id=cd1f2cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1f2cca",
  null
  
)

export default component.exports